import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { openQHelp } from '../../utils/qHelpWidget';

export default class InsufficientCreditCheckModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
  }

  // Zendesk is gone: Q Help (or the support mailbox where no widget loaded).
  handleTopUpCredits = (e) => {
    e.preventDefault();
    this.props.onClose(e);
    openQHelp();
  }

  render() {
    return (
      <Modal
        className="manage manage-credit-check"
        dimmer
        closeOnDimmerClick
        open={this.props.open}
        size="small"
      >
        <Header icon="warning sign" content="Insufficient credits" />
        <Modal.Content>
          <h4>
            <span>
              <p>
                Not enough balance to perform a Credit Check. Please contact the admin
              </p>
            </span>
          </h4>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={e => this.props.onClose(e)} color="grey">
            <Icon name="remove" /> Cancel
          </Button>
          <Button
            color="green"
            as="a"
            onClick={this.handleTopUpCredits}
          >
            <Icon name="plus" /> Top Up
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/InsufficientCreditCheck.jsx